(function () {
  if (window.__brevoNewsletterInit) return;
  window.__brevoNewsletterInit = true;

  function getWrapper(form) {
    return (
      form.closest('.newsletter-brevo-form') ||
      form.closest('.brevo-newsletter-popup-sections') ||
      form.closest('.brevo-form-ajax') ||
      form.parentElement
    );
  }

  function getFeedback(form) {
    var wrapper = getWrapper(form);
    if (!wrapper) return null;

    var feedback = wrapper.querySelector('.brevo-form-feedback');
    if (!feedback) {
      feedback = document.createElement('p');
      feedback.className = 'brevo-form-feedback';
      feedback.setAttribute('role', 'status');
      feedback.hidden = true;
      wrapper.appendChild(feedback);
    }

    return feedback;
  }

  function showFeedback(form, type, message) {
    var feedback = getFeedback(form);
    if (!feedback) return;

    feedback.hidden = false;
    feedback.className = 'brevo-form-feedback brevo-form-feedback--' + type;
    feedback.textContent = message;
  }

  function setLoading(form, loading) {
    var button = form.querySelector('[type="submit"]');
    if (!button) return;

    button.disabled = loading;
    button.setAttribute('aria-busy', loading ? 'true' : 'false');
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.action || form.action.indexOf('sibforms.com/serve/') === -1) return;

      event.preventDefault();

      var feedback = getFeedback(form);
      if (feedback) {
        feedback.hidden = true;
        feedback.className = 'brevo-form-feedback';
      }

      setLoading(form, true);

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        mode: 'cors',
        credentials: 'omit',
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data && data.success) {
            showFeedback(
              form,
              'success',
              data.message || 'Deine Anmeldung war erfolgreich.'
            );
            form.reset();
            form.classList.add('brevo-form-submitted');
            return;
          }

          showFeedback(
            form,
            'error',
            (data && data.message) ||
              'Deine Anmeldung konnte nicht gespeichert werden. Bitte versuche es erneut.'
          );
        })
        .catch(function () {
          showFeedback(
            form,
            'error',
            'Deine Anmeldung konnte nicht gespeichert werden. Bitte versuche es erneut.'
          );
        })
        .finally(function () {
          setLoading(form, false);
        });
    },
    true
  );
})();
